class LogoListScroller {
  constructor() {
    this.selector = ".logo-list";
    this.scrollIntervals = new Map(); // Keep track of intervals for each element
    this.init();
  }

  init() {
    if (window.LogoListScrollerInitialized) return; // Check if already initialized
    window.LogoListScrollerInitialized = true;

    const logoLists = document.querySelectorAll(this.selector);
    if (!logoLists.length) return;

    logoLists.forEach((logoList) => {
      const sliderTimer = parseInt(logoList.getAttribute("data-slider-timer")) * 1000 || 2000; 
      if (!this.scrollIntervals.has(logoList)) {
        let scrollAmount = 0;
        this.scrollAutomaticRight(scrollAmount, logoList, sliderTimer);
      }
    });
  }

  scrollAutomaticLeft(scrollAmount, elemToScroll, sliderTimer) {
    const scrollLeft = setInterval(() => {
      elemToScroll.scrollTo({
        left: Math.max(scrollAmount, 0), // Ensure the scroll amount doesn't go below 0
        behavior: "smooth",
      });
      //lets check if its mobile, if mobile we scroll 135px
      if (window.innerWidth < 768) {
        scrollAmount -= 145;
      } else{
        scrollAmount -= 200;
      }
      if (scrollAmount <= 0) {
        clearInterval(scrollLeft);
        this.scrollAutomaticRight(0, elemToScroll, sliderTimer); // Reset scrollAmount to 0
      }
    }, sliderTimer);

    this.scrollIntervals.set(elemToScroll, scrollLeft);
  }

  scrollAutomaticRight(scrollAmount, elemToScroll, sliderTimer) {
    const scrollRight = setInterval(() => {
      const maxScrollLeft = elemToScroll.scrollWidth - elemToScroll.clientWidth;
      elemToScroll.scrollTo({
        left: Math.min(scrollAmount, maxScrollLeft), // Ensure the scroll amount doesn't exceed maxScrollLeft
        behavior: "smooth",
      });
      if (window.innerWidth < 768) {
        scrollAmount += 145;
      } else{
        scrollAmount += 200;
      }
      if (scrollAmount >= maxScrollLeft) {
        clearInterval(scrollRight);
        this.scrollAutomaticLeft(maxScrollLeft, elemToScroll, sliderTimer); // Start scrolling left from the end
      }
    }, sliderTimer);

    this.scrollIntervals.set(elemToScroll, scrollRight);
  }
}

// Initialize the class
new LogoListScroller();
